<template>
  <div>
    <RunProgressBar :key="currentStep + '_' + isRunning + '_progress'" />
    <br>
    <p>
      Here you can decide how many years to simulate and make changes to
      improve conditions.
    </p>
    <div :key="currentStep + '_' + isRunning + '_buttons'">
      <div class="btn-group whats-next-container">
        <button
          type="button"
          class="btn btn-lg btn-primary dropdown-toggle whats-next-button"
          :disabled="isRunning"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Run the model <span class="caret" />
        </button>
        <ul class="dropdown-menu">
          <li @mouseover="runSubmenuButtonOut">
            <template v-if="currentRun.getScenario()">
              <router-link to="/interventions">
                Select interventions
              </router-link>
            </template>
            <template v-else>
              <a class="muted">Select interventions</a>
            </template>
          </li>
          <li class="dropdown dropdown-submenu">
            <template v-if="!isRunning && currentStep < runToEndFinishesAt">
              <a
                class="dropdown-toggle"
                data-toggle="dropdown"
                @click.prevent="runSubmenuButtonClicked"
                @mouseover="runSubmenuButtonOver"
              >Run the model</a>
            </template>
            <template v-else>
              <a class="muted">Run the model</a>
            </template>
            <ul :class="'dropdown-menu ' + runSubmenuClass">
              <li>
                <template v-if="!isRunning && currentStep < runToEndFinishesAt">
                  <a
                    href
                    @click.prevent="runMultipleButtonClicked"
                  >
                    Choose how many years to run
                  </a>
                </template>
                <template v-else>
                  <a class="muted">Choose how many years to run</a>
                </template>
              </li>
              <li>
                <template v-if="!isRunning && currentStep < runToEndFinishesAt">
                  <a
                    href
                    @click.prevent="runToEnd"
                  >Run to the end of the simulation</a>
                </template>
                <template v-else>
                  <a class="muted">Run to the end of the simulation</a>
                </template>
              </li>
            </ul>
          </li>
          <li @mouseover="runSubmenuButtonOut">
            <template v-if="currentRun.getCurrentStep() > 1">
              <router-link to="/results">
                View results
              </router-link>
            </template>
            <template v-else>
              <a class="muted">View results</a>
            </template>
          </li>
          <!-- <li @mouseover="runSubmenuButtonOut">
            <template
              v-if="currentStep >= runToEndFinishesAt && !isLoadedFromSaved"
            >
              <a
                href
                @click.prevent="saveResultButtonClicked"
              >Save results</a>
            </template>
            <template v-else>
              <a class="muted">Save results</a>
            </template>
          </li> -->
          <li @mouseover="runSubmenuButtonOut">
            <template v-if="currentStep >= runToEndFinishesAt && !isLoadedFromSaved">
              <router-link to="/lessons">
                Save &amp; submit
              </router-link>
            </template>
            <template v-else>
              <a class="muted">Save &amp; submit</a>
            </template>
          </li>
          <li @mouseover="runSubmenuButtonOut">
            <template v-if="currentStep > 0 && !isRunning">
              <a href="/">Start again</a>
            </template>
            <template v-else>
              <a class="muted">Start again</a>
            </template>
          </li>
        </ul>
        <template v-if="isRunning">
          <span class="glyphicon glyphicon-refresh spinning" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../services/data";
import forioWrapper from "../services/ForioWrapper";
import router from "../router";
import RunProgressBar from "./RunProgressBar.vue";

export default {
  components: {
    RunProgressBar
  },
  data() {
    return {
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      isLoadedFromSaved: false,
      currentStep: 0,
      isRunning: false,
      runStages: data.runStages,
      maxNumberOfRuns: data.maxNumberOfRuns,
      runToEndFinishesAt: data.runToEndFinishesAt,
      sharedStorage: this.$root.$data.sharedStorage,
      runSubmenuClass: ""
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.isRunning = this.currentRun.isRunning();
    this.currentStep = this.currentRun.getCurrentStep();
    this.isLoadedFromSaved = this.currentRun.isLoadedFromSaved();

    this.$root.$data.eventHub.$on("show-runmultiple-trigger", numberOfSteps => {
      this.runMultipleModalReturned(numberOfSteps);
    });

    this.$root.$data.eventHub.$on("show-namesavedrun-trigger", name => {
      this.saveResult(name);
    });
  },
  updated() {
    this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
  },
  methods: {
    runSubmenuButtonClicked() {
      this.runSubmenuClass = this.runSubmenuClass === "open" ? "" : "open";
    },
    runSubmenuButtonOver() {
      this.runSubmenuClass = "open";
    },
    runSubmenuButtonOut() {
      this.runSubmenuClass = "";
    },
    runToEnd() {
      const i = this.currentRun.getCurrentStep();
      this.doSteps(Math.max(1, data.runToEndFinishesAt - i));
    },
    runOne() {
      this.doSteps(1);
    },
    runMultipleButtonClicked() {
      this.$root.$data.eventHub.$emit("show-runmultiple-modal");
    },
    runMultipleModalReturned(result) {
      this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
      let i = this.currentRun.getCurrentStep();
      const multiplier = Math.min(
        this.maxNumberOfRuns - i - 1,
        Math.max(1, parseInt(result * 2 || 1))
      );
      if (!multiplier) {
        return;
      }

      this.doSteps(multiplier);
    },
    async doSteps(numberOfSteps) {
      this.isRunning = true;
      await forioWrapper.doSteps({
        Run: this.currentRun,
        numberOfSteps: numberOfSteps,
        maxRetries: 3
      });

      this.isRunning = this.currentRun.isRunning();
      this.currentStep = this.currentRun.getCurrentStep();
      this.isLoadedFromSaved = this.currentRun.isLoadedFromSaved();

      this.$router.push("/results").catch(() => {});
      this.$root.$data.eventHub.$emit("new-data-arrived");
    },
    saveResultButtonClicked() {
      this.$root.$data.eventHub.$emit("show-namesavedrun-modal");
    },
    saveResult(name) {
      this.sharedStorage.saveRun({ name });
      this.sharedStorage.startNewRun();

      router.push({ path: "/" });
      document.location.href = "/";
    }
  }
};
</script>

<style lang="scss">
.last-run-button {
  margin-right: 20px;
}
.dropdown-menu > li > a.muted {
  color: #aaa;
}
.whats-next-container {
  margin-top: 20px;

  .spinning {
    margin-top: 12px;
    margin-left: 15px;
  }
}
.whats-next-button {
  padding: 8px 12px;
  margin: 0;
  border-radius: 0px;
  border-style: solid;
  border-width: 0 0 4px 0;
  background: #009482;
}
.whats-next-button:hover {
  background: #009482;
  border-color: #fff;
  color: #fff;
}
</style>
